var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isListenerMobile)?_c('ListenerArtistLibrary'):_c('ArtistLibrary')
}
var staticRenderFns = []

export { render, staticRenderFns }